/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/noop */
function o(){}export{o as noop};
//# sourceMappingURL=noop.mjs.map